import { datadogRum } from "@datadog/browser-rum";
import packageJson from "@/../package.json";
import { Countries } from "@/types/Countries";

const sampleRate = process.env.VUE_APP_K8_ENVIRONMENT_NAME === "staging" ? 100 : 3;
const sessionReplayRate = process.env.VUE_APP_K8_ENVIRONMENT_NAME === "staging" ? 50 : 5;

/**
 * Start Datadog RUM once for Mexican devices; other countries are not tracked.
 */
export const initializeDatadogRum = (country: string | undefined): void => {
  if (country === Countries.MEXICO && !datadogRum.getInitConfiguration()) {
    console.log("Initializing Datadog RUM");
    datadogRum.init({
      applicationId: process.env.VUE_APP_DATADOG_APPLICATION_ID as string,
      clientToken: process.env.VUE_APP_DATADOG_CLIENT_TOKEN as string,
      site: "datadoghq.com",
      service: "payoptions",
      env: process.env.VUE_APP_K8_ENVIRONMENT_NAME as string,
      version: packageJson.version,
      sessionSampleRate: sampleRate,
      sessionReplaySampleRate: sessionReplayRate,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: "mask-user-input",
    });
    console.log("Datadog RUM initialized successfully");
  }
};
